import { render } from "./IdentifyConfirm.vue?vue&type=template&id=20133858"
import script from "./IdentifyConfirm.vue?vue&type=script&lang=js"
export * from "./IdentifyConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__